import React from 'react'
import { useParams } from 'react-router-dom';

import { Content } from './styled';
import LiveWistiaPlayer from 'components/LiveWistiaPlayer';

export default function Live() {
  const { id } = useParams();

  return (
    <>
      <Content>
        <LiveWistiaPlayer mediaId={id} />
      </Content>
    </>

  )
}
